import React from "react";
import Img from "gatsby-image";

const People = ({ people }) => {
  return (
    <section className="about-page__people grid pt-v5 xs:pt-v10 text-orange">
      {people?.[0] &&
        people.map((person, index) => {
          const personKey = `${person.name}-key-${index}`;

          return <Person key={personKey} person={person} />;
        })}
    </section>
  );
};

export default People;

const Person = ({ person }) => {
  return (
    <article className="about-page__people-card grid-end-4 xs:grid-end-8 relative mb-v7 xs:mb-v14">
      {person?.image?.childImageSharp?.fluid ? (
        <Img
          className="people-square mb-v1 bg-orange"
          fluid={person.image.childImageSharp.fluid}
          alt={person.name}
        />
      ) : (
        <div className="people-square mb-v1 bg-orange"></div>
      )}

      <div className="about-page__people-card__text w-full flex justify-between xs:mt-v3">
        <h3 className="b2 universal-sans" style={{ flexBasis: `50%` }}>
          {person.name}
        </h3>

        <p className="b2 universal-sans" style={{ flexBasis: `50%` }}>
          <span>{person.title}</span>
          <br />
          <span>{person.location}</span>
        </p>
      </div>

      <p className="w-full mt-v2 xs:mt-v4 b2 universal-sans">{person.text}</p>
    </article>
  );
};
